// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"e525fe26","453":"b53bba07","667":"e5bbfb50","743":"2bdebd42","910":"6d22664f","977":"6dea786b"}[chunkId] + ".chunk.js";
};